import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AllTestTableComp from "./Component/AllTestTableComp"

const AllTestTable =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
             <AllTestTableComp/>
        </div>
        <Footer />
        </>
    )
}

export default AllTestTable